import { createContext, useContext, useState, useEffect, useCallback } from 'react'
import { obtenerConfig, guardarConfig as guardarConfigDB } from '../db/config'

const ConfigContext = createContext(null)

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState({ nombreTienda: 'Mi Tienda', fiadoHabilitado: false, imprimirTicket: false })

  const cargar = useCallback(async () => {
    const c = await obtenerConfig()
    setConfig(prev => ({ ...prev, ...c }))
  }, [])

  useEffect(() => { cargar() }, [cargar])

  useEffect(() => {
    document.title = config.nombreTienda
  }, [config.nombreTienda])

  async function guardarConfig(datos) {
    await guardarConfigDB(datos)
    setConfig(prev => ({ ...prev, ...datos }))
  }

  return (
    <ConfigContext.Provider value={{ config, guardarConfig, recargarConfig: cargar }}>
      {children}
    </ConfigContext.Provider>
  )
}

export function useConfig() {
  return useContext(ConfigContext)
}
